// extracted by mini-css-extract-plugin
export default {"layout":"_237af3e92b _1cee7417be _252c2364dd","h_slide":"_414ae1a62d","category":"_356a0de5c6 faac1853f9 _5e385c683e"};